export class Industries {
    http;
    constructor(http) {
        this.http = http;
    }
    getIndustries() {
        return this.http.get(`/api/industries`).json();
    }
}
